import { Comparator, ComparatorItem } from 'src/common/types/Comparator.ts';

const order = [
    'Open/close',
    '3-point',
    'modulating',
    'communicative',
    'hybrid',
    'Cloud',
    'Manual',
];

const mapMinusOne = (item: number) => (item === -1 ? 9999 : item);

export const initComparatorFor281 = ():Comparator => (a: ComparatorItem, b: ComparatorItem) => {
    if (a.value === b.value) {
        return 0;
    }
    const aIndex = order.findIndex((i) => i === a.value);
    const bIndex = order.findIndex((i) => i === b.value);
    return mapMinusOne(aIndex) > mapMinusOne(bIndex) ? 1 : -1;
};
